import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
const Counter = () => {
  const starsCountRef = useRef(null);
  const downloadsCountRef = useRef(null);
  const sponsorsCountRef = useRef(null);
  const clientCountRef = useRef(null);
  const targets = [
    {
      element: starsCountRef,
      count: 4670,
      suffix: "+",
    },
    {
      element: downloadsCountRef,
      count: 80000,
      suffix: "+",
    },
    {
      element: sponsorsCountRef,
      count: 80000,
      suffix: "+",
    },

    {
      element: clientCountRef,
      count: 100,
      suffix: "+",
    },
  ];

  // Function to animate count-up effect
  function animateCountUp(target, duration) {
    let currentCount = 0;
    const increment = Math.ceil(target.count / (duration / 10));

    const interval = setInterval(() => {
      currentCount += increment;
      if (currentCount >= target.count) {
        clearInterval(interval);
        currentCount = target.count;
      }
      if (target.element.current) {
        target.element.current.textContent = currentCount + target.suffix;
      }
    }, 10);
  }

  useEffect(() => {
    const maxCount = Math.max(...targets.map((target) => target.count));
    const duration = 2000; // Duration of the animation in milliseconds

    targets.forEach((target) => {
      animateCountUp(target, duration);
    });
  }, [targets]);

  return (
    <div className=" bg-gray-50">
      <div className=" max-w-7xl mx-auto pt-2  sm:pt-12 px-4 sm:px-6 lg:px-8 ">  
        <div className="pb-12 mt-10   sm:pb-16">
          <div className="grid md:grid-cols-2 items-center gap-10">
            <div>
              <span className="bg-amber-400 px-6 py-1 rounded-full text-base mb-3">IT Skills</span>
              <h2 className="md:text-5xl text-3xl font-semibold mb-4 ">
                {" "}
                Take Your IT Skills to the Next Level
              </h2>
              <p className="text-justify">
                {" "}
                IT skills are in high demand and can help you get a better job
                or start your own business. We offer a variety of IT courses to
                help you learn the skills you need to succeed. Get started
                today!
              </p>
              <h2 className="text-xl font-bold mt-4 text-black dark:text-black  ">
                Trusted by IT Professionals Worldwide
              </h2>
              <p className="mt-1 text-lg  text-black dark:text-black ">
                Get the practical IT skills and knowledge needed to confidently
                pursue your dream IT job.
              </p>
              <div className="mt-8">
                <div className="flex items-center">
                  <Link
                    to="/contact"
                    className="rounded-md bg-amber-700 hover:bg-amber-800 px-3.5 py-2.5 text-sm font-semibold text-gray-100 shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                  >
                    Join Now
                  </Link>
                </div>
              </div>
            </div>
            <div className="w-full h-full">
              <img
                src="./edu.gif"
                alt="Learn it with brain box study"
                className="w-full h-[400px] object-cover"
              />
            </div>
          </div>
          <div className="relative mt-6">
            <div className="absolute inset-0 h-1/2 " />
            <div className="relative">
              <div className="max-w-7xl mx-auto">
                <dl className="  rounded-lg sm:grid sm:grid-cols-4 gap-4">
                  <div className="flex bg-white shadow-md hover:shadow-lg border-gray-300 flex-col p-6 mr-2 text-center   dark:border-gray-500   border">
                    <dt className="order-2 mt-2 text-lg font-medium leading-6 text-black dark:text-black">
                      Skilled Professionals
                    </dt>
                    <dd
                      className="order-1 text-5xl font-extrabold leading-none text-black dark:text-black"
                      ref={starsCountRef}
                    >
                      5000
                    </dd>
                  </div>
                  <div className="flex  bg-white mr-2 shadow-md hover:shadow-lg  flex-col p-6 text-center  border-gray-300 dark:border-gray-700 border">
                    <dt className="order-2 mt-2 text-lg font-medium leading-6 text-black dark:text-black">
                      Daily Learners
                    </dt>
                    <dd
                      className="order-1 text-5xl font-extrabold leading-none text-black dark:text-black"
                      ref={downloadsCountRef}
                    >
                      5000
                    </dd>
                  </div>
                  <div className="bg-white mr-2 shadow-md hover:shadow-lg  flex flex-col p-6 text-center  border-gray-300 dark:border-gray-700 border">
                    <dt className="order-2 mt-2 text-lg font-medium leading-6 text-black dark:text-black">
                      Global Market Impact
                    </dt>
                    <dd
                      className="order-1 text-5xl font-extrabold leading-none text-black dark:text-black"
                      ref={sponsorsCountRef}
                    >
                      5000
                    </dd>
                  </div>
                  <div className="flex bg-white shadow-md hover:shadow-lg  flex-col p-6 text-center  border-gray-200 dark:border-gray-700 border">
                    <dt className="order-2 mt-2 text-lg font-medium leading-6 text-black dark:text-black">
                      Success Rate
                    </dt>
                    <dd
                      className="order-1 text-5xl font-extrabold leading-none text-black dark:text-black"
                      ref={sponsorsCountRef}
                    >
                      0
                    </dd>
                  </div>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Counter;
